export const gameTypes = [
  { name: 'default-game-type', label: 'Brasileiro (64 casas)', value: {boardSize: 64, lineSize: 8, columnSize: 8, piecesPerPlayer: 12}},
  { name: 'global-game-type', label: 'Mundial (100 casas)', value: {boardSize: 100, lineSize: 10, columnSize: 10, piecesPerPlayer: 20}}
]